<script>
import { GlForm, GlLoadingIcon } from '@gitlab/ui';
import { logError } from '~/lib/logger';
import csrf from '~/lib/utils/csrf';
import { initArkoseLabsScript } from '../init_arkose_labs_script';
import { VERIFICATION_TOKEN_INPUT_NAME, CHALLENGE_CONTAINER_CLASS } from '../constants';

export default {
  name: 'IdentityVerificationArkoseApp',
  csrf,
  components: { GlForm, GlLoadingIcon },
  props: {
    publicKey: {
      type: String,
      required: true,
    },
    domain: {
      type: String,
      required: true,
    },
    sessionVerificationPath: {
      type: String,
      required: true,
    },
    dataExchangePayload: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      arkoseLabsIframeShown: false,
      arkoseToken: '',
    };
  },
  async mounted() {
    try {
      await this.initArkoseLabs();
    } catch (error) {
      logError('ArkoseLabs initialization error', error);
      this.submit();
    }
  },
  methods: {
    onArkoseLabsIframeShown() {
      this.arkoseLabsIframeShown = true;
    },
    async initArkoseLabs() {
      const arkoseObject = await initArkoseLabsScript({
        publicKey: this.publicKey,
        domain: this.domain,
      });

      const blob = this.dataExchangePayload;
      const data = blob ? { data: { blob } } : {};

      arkoseObject.setConfig({
        ...data,
        mode: 'inline',
        selector: `.${this.$options.CHALLENGE_CONTAINER_CLASS}`,
        onShown: this.onArkoseLabsIframeShown,
        onCompleted: this.submit,
      });
    },
    submit({ token } = { token: '' }) {
      this.arkoseToken = token;

      this.$nextTick(() => {
        this.$refs.form.$el.submit();
      });
    },
  },
  VERIFICATION_TOKEN_INPUT_NAME,
  CHALLENGE_CONTAINER_CLASS,
};
</script>

<template>
  <gl-form
    ref="form"
    :action="sessionVerificationPath"
    method="post"
    data-testid="arkose-labs-token-form"
  >
    <input :value="$options.csrf.token" type="hidden" name="authenticity_token" />
    <input
      :name="$options.VERIFICATION_TOKEN_INPUT_NAME"
      type="hidden"
      :value="arkoseToken"
      data-testid="arkose-labs-token-input"
    />
    <div
      class="gl-display-flex gl-justify-content-center"
      :class="$options.CHALLENGE_CONTAINER_CLASS"
    >
      <gl-loading-icon v-if="!arkoseLabsIframeShown" size="lg" class="gl-my-4" />
    </div>
  </gl-form>
</template>
